import React, { useState, useRef, useCallback } from "react";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import Modal from "./imageModal";

const ImageFreeCropper = ({ imageSrc, setCroppedImage, onClose }) => {
    const [crop, setCrop] = useState({ unit: "%", width: 50, height: 50 });
    const [completedCrop, setCompletedCrop] = useState(null);
    const imgRef = useRef(null);

    const onImageLoad = useCallback((img) => {
        imgRef.current = img;

        // Jika user tidak meng-crop secara manual, gunakan full image
        setCompletedCrop({
            unit: "px",
            x: 0,
            y: 0,
            width: img.width,
            height: img.height,
        });
    }, []);

    const applyCrop = async () => {
        if (!completedCrop || !imgRef.current) return;

        const image = imgRef.current;
        const canvas = document.createElement("canvas");
        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;

        canvas.width = completedCrop.width * scaleX;
        canvas.height = completedCrop.height * scaleY;

        const ctx = canvas.getContext("2d");

        ctx.drawImage(
            image,
            completedCrop.x * scaleX,
            completedCrop.y * scaleY,
            completedCrop.width * scaleX,
            completedCrop.height * scaleY,
            0,
            0,
            completedCrop.width * scaleX,
            completedCrop.height * scaleY
        );

        canvas.toBlob(
            (blob) => {
                if (!blob) return;

                const croppedFile = new File([blob], "cropped.jpg", {
                    type: "image/jpeg",
                });

                const previewURL = URL.createObjectURL(blob);

                // kirim ke parent
                setCroppedImage(croppedFile, previewURL);

                onClose();
            },
            "image/jpeg",
            1
        );
    };

    return (
        <Modal isOpen={true} onClose={onClose}>
            <div
                style={{
                    maxWidth: "90vw",
                    maxHeight: "70vh",
                    overflow: "auto",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <ReactCrop
                    crop={crop}
                    onChange={(c) => setCrop(c)}
                    onComplete={(c) => setCompletedCrop(c)}
                >
                    <img
                        src={imageSrc}
                        onLoad={(e) => onImageLoad(e.currentTarget)}
                        alt="crop-target"
                        style={{ maxWidth: "100%", height: "auto" }}
                    />
                </ReactCrop>
            </div>

            <div className="mt-3" style={{ display: "flex", gap: "12px" }}>
                <button className="btn btn-primary" onClick={applyCrop}>
                    Apply
                </button>
                <button className="btn btn-secondary" onClick={onClose}>
                    Close
                </button>
            </div>
        </Modal>
    );
};

export default ImageFreeCropper;
